import React, { useState } from "react";
// import graph from "./graph";
// import Update from "./Update";
import VisibilityRoundedIcon from "@mui/icons-material/VisibilityRounded";

import {
  Chip,
  Fade,
  Card,
  Stack,
  Button,
  Typography,
  CardHeader,
  CardContent,
  CardActions,
  CardActionArea,
  Box,
  Popover,
} from "@mui/material";

import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { hasRequiredRole } from "helpers";
import { FormattedMessage } from "react-intl";
import { AvatarPopover, CountdownTimer, CustomList, NewMediaPopup } from "components";
import { addCommas } from "@persian-tools/persian-tools";

export default function Model({
  model,
  delay,
  checked,
  refetch,
  isAssign,
  selectable,
  handleSelect,
}) {
  const {
    id,
    tracking_code,
    status,
    lab,
    unit,
    doctor,
    total_cost,
    customer,
    created_at,
    demand_time,
    delivery_time,
  } = model;
  const { userInfo } = useSelector((state) => state.auth);
  return (
    <>
      <Fade
        in
        unmountOnExit
        timeout={{ appear: delay * 150, enter: delay * 170, exit: delay * 190 }}
      >
        <Stack direction="row" alignItems="center">
          <Card
            sx={{
              width: "100%",
              position: "relative",
              borderColor: checked && "primary.main",
              bgcolor: checked && "action.disabledBackground",
            }}
            variant="outlined"
          >
            <CardHeader
              sx={{ p: 1 }}
              // avatar={
              //   <NewMediaPopup
              //     id={id}
              //     title={title}
              //     graph={graph}
              //     model="Order"
              //     collection="avatar"
              //   >
              //     <AvatarPopover
              //       isAssign={isAssign}
              //       media={media[0]?.full_url}
              //       sx={{ width: 48, height: 48 }}
              //     />
              //   </NewMediaPopup>
              // }
              title={
                <Typography variant="caption" color="text.disabled">
                  شماره سفارش
                </Typography>
              }
              subheader={
                <Typography
                  variant="subtitle1"
                  color="text.secondary"
                  fontSize={16}
                  letterSpacing={3}
                >
                  {tracking_code.split(".")[1]}
                </Typography>
              }
              // subheader={
              //   <Typography fontSize={12} variant="subtitle2">
              //     {`بیمار: ${customer.firstname} ${customer.lastname}`}
              //   </Typography>
              // }
              action={
                <Chip sx={{ width: 160 }} size="small" label={status?.title} />
              }
            />
            <CardContent sx={{ p: 1 }}>
              <CustomList
                data={{
                  title: "بیمار",
                  // value: addCommas(Number(total_cost)),
                  // unit: "تومان",
                  value: `${customer.firstname} ${customer.lastname}`,
                  children: [
                    {
                      title: "لابراتوار",
                      value: lab?.title,
                    },
                    {
                      title: "کلینیک",
                      value: unit?.title,
                    },
                    {
                      title: "پزشک معالج",
                      value: `${doctor?.firstname} ${doctor?.lastname}`,
                    },
                  ],
                }}
              />
            </CardContent>
            <CardActions sx={{ justifyContent: "space-between" }}>
              <DatePopover
                created={created_at}
                demanded={demand_time}
                delivered={delivery_time}
              />

              {/* {isSuperadmin && (
                <Update
                  ids={id}
                  refetch={refetch}
                  title={<FormattedMessage id="update" />}
                />
              )} */}
              <Button
                LinkComponent={Link}
                to={`/order/${id}`}
                variant="contained"
                size="small"
                color="secondary"
                endIcon={<VisibilityRoundedIcon fontSize="small" />}
              >
                جزییات
              </Button>
            </CardActions>
            <CardActionArea
              sx={{
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                zIndex: 1,
                position: "absolute",
              }}
              onClick={handleSelect}
              disabled={!isAssign && !selectable}
            />
          </Card>
        </Stack>
      </Fade>
    </>
  );
}

const OrderDate = ({
  title,
  date,
  color = "warning.darker",
  bgcolor = "warning.lighter",
}) =>
  date && (
    <Stack direction="row" columnGap={1} alignItems="center">
      <Typography width={80} variant="subtitle1" fontSize={12}>
        {title}
      </Typography>
      <CountdownTimer targetDate={date} color={color} bgcolor={bgcolor} />
    </Stack>
  );

const DatePopover = ({ created, demanded, delivered }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box>
      <Button
        size="small"
        color="inherit"
        aria-owns={open ? `mouse-over-popover-date` : undefined}
        aria-haspopup="true"
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
      >
        {demanded ? (
          <CountdownTimer
            targetDate={demanded}
            color="warning.darker"
            bgcolor="warning.lighter"
          />
        ) : (
          <CountdownTimer
            targetDate={created}
            color="info.darker"
            bgcolor="info.lighter"
          />
        )}
      </Button>
      <Popover
        id={`mouse-over-popover-date`}
        sx={{
          pointerEvents: "none",
          direction: "ltr",
          bgcolor: "transparent",
        }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "center",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "center",
          horizontal: "right",
        }}
        onClose={handlePopoverClose}
        hideBackdrop
      >
        <Stack p={1} rowGap={1} bgcolor="transparent">
          <OrderDate title="تاریخ ثبت" date={created} />
          <OrderDate title="تاریخ درخواست" date={demanded} />
          <OrderDate
            title="تاریخ تحویل"
            date={delivered}
            color="success.darker"
            bgcolor="success.lighter"
          />
        </Stack>
      </Popover>
    </Box>
  );
};
